import React from 'react';

//HELPERS
import {_} from '../../../locale';

//STYLES
import styles from './styles.css';
import layoutStyles from '../../../styles/layout.css';

const Error404 = () => {
    return (
        <section className={layoutStyles.container}>
            <div className={layoutStyles.content}>
                <h2 className={styles.h2}>{_("La poética del error te ha traído hasta aquí.\n ¡Viva el errorismo!")}</h2>
                <div className={styles.content}>
                    <div className={styles.photo}>
                        <div className={styles.error}/>
                    </div>
                    <div>
                        <p className={styles.text}>{_("Has llegado hasta uno de los lugares maravillosos que habitamos. Puedes quedarte aquí soñando despierta o")} <a href='https://www.bitamine.net'>{_("volver")}</a> {_("a nuestro hogar dulce hogar electrónico.")}</p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Error404
